import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import Globalize from "globalize";
import Button from "components/form/button";
import { merge, $, media } from "glamor";
import theme from "styles/theme";
import RequestAccessPopup from "./request-access-popup";
import memoize from "lodash/memoize";
import get from "lodash/get";
import { format } from "lib/globalize-util";
import { DISPLAY_ALL_PRODUCTS_TO_GUEST_BUYER } from "containers/admin/settings/online-trade-show";
import { DATATEST } from "constants/integration";

const style = {
    button: {
        margin: "10px 0",
    },
    dialogContent: {
        maxWidth: "600px",
        paddingBottom: "60px",
        height: "1000px",
    },
    warning: {
        backgroundColor: theme.palette.editing,
        padding: "16px",
        maxWidth: "550px",
    },
};

/** @augments {PureComponent<any, any>} */
class RequestAccessHeader extends PureComponent {
    static propTypes = {
        showInstructions: PropTypes.bool,
        onMakeAccessRequest: PropTypes.func.isRequired,
        onCreateBuyerProfile: PropTypes.func.isRequired,
        requestAccessStyle: PropTypes.object,
        canOpenImmediately: PropTypes.bool,
        showDialog: PropTypes.bool,
        isPendingConnection: PropTypes.bool,
        isBrandPageOfShowSite: PropTypes.bool,
        isBrandProfilePage: PropTypes.bool,
        isGuestBuyer: PropTypes.bool,
        onClearCompany: PropTypes.func,
        onClearBrand: PropTypes.func,
    };

    static contextTypes = {
        router: PropTypes.object.isRequired,
    };

    static defaultProps = {
        showDialog: false,
        showInstructions: true,
    };
    styles = merge(
        {
            display: "flex",
        },
        $(" .requestAccess", {
            display: "flex",
            padding: "0 16px",
            margin: "0 auto",
            flexWrap: "wrap",
            position: "relative",
        }),
        // $(" .requestAccess .requestAccessTooltip", {
        //     position: "absolute",
        //     top: "100%",
        //     left: "0px",
        //     right: "0px",
        //     textAlign: "center",
        //     backgroundColor: "rgba(0,0,0,.8)",
        //     color: "white",
        //     fontSize: "14px",
        //     padding: "12px",
        //     display: "none",
        //     zIndex: 5,
        // }),
        // $(" .requestAccess:hover .requestAccessTooltip", {
        //     display: "block",
        // }),
        // $(" .requestAccess .requestAccessTooltip .triangle", {
        //     content: "",
        //     display: "block",
        //     width: "0",
        //     height: "0",
        //     position: "absolute",
        //     borderLeft: "8px solid transparent",
        //     borderRight: "8px solid transparent",
        //     borderBottom: "8px solid rgba(0,0,0,.8)",
        //     left: "50%",
        //     transform: "translateX(-50%)",
        //     top: "-8px",
        //     zIndex: 4,
        // }),
        $(" .requestAccess h2", {
            fontSize: "16px",
            lineHeight: "1.5",
            height: "24px",
            fontWeight: "bold",
        }),
        $(".isMobile & .seeMoreProducts", {
            display: "none !important",
        }),
        media(
            "(min-width: 240px) AND (max-width: 689px)",
            $(" .requestAccess", {
                width: "200px",
                padding: "0px",
            }),
            $(" .requestAccess .requestCTA > div > span", {
                padding: "10px !important",
            }),
            $(" .requestAccess .requestCTA > span", {
                padding: "10px !important",
            })
        )
    );

    constructor(props, context) {
        super(props, context);
        const { query } = context.router.location;
        this.state = {
            open: props.showDialog || (props.canOpenImmediately && !!query.connectTo),
            message: "",
        };
    }

    UNSAFE_componentWillMount() {
        const { me } = this.props;
        if (me.retailers && me.retailers.length) {
            this.setState({
                retailerId: me.retailers[0]._id,
            });
        }
    }

    handleShowDialog = memoize((open) => () => this.setState({ open }));

    handleTrackShopBrandClick = () => {
        this.props.onTrackShopBrandClick(this.props.activeBrand._id);
    };

    handleVisitBrandPortalClick = () => {
        const { activeBrand } = this.props;
        this.context.router.push(`/brand/${activeBrand._id}`);
    };

    render() {
        const {
            requestAccessStyle,
            pathname,
            large,
            activeBrand = {},
            me,
            onMakeAccessRequest,
            isFetching,
            showDialog,
            onCreateBuyerProfile,
            isPendingConnection,
            isBrandPageOfShowSite,
            isBrandProfilePage,
            isGuestBuyer,
            onClearCompany,
            onClearBrand,
        } = this.props;
        const { open } = this.state;
        const brandInfo = {
            _id: activeBrand._id,
            name: activeBrand.name,
            dashboard_logo_image: get(activeBrand, "settings.dashboard_logo_image"),
            initials: activeBrand._initials,
        };

        const guestBuyerProductWhitelist = activeBrand.settings.guest_buyer_product_whitelist_values;
        const displayAllProductsToGuestBuyers =
            guestBuyerProductWhitelist?.[0]?.name === DISPLAY_ALL_PRODUCTS_TO_GUEST_BUYER.name &&
            guestBuyerProductWhitelist?.[0]?.product_filter_values?.[0]?.field ===
                DISPLAY_ALL_PRODUCTS_TO_GUEST_BUYER.product_filter_values[0].field &&
            guestBuyerProductWhitelist?.[0]?.product_filter_values?.[0]?.values?.[0] ===
                DISPLAY_ALL_PRODUCTS_TO_GUEST_BUYER.product_filter_values[0].values[0];

        // you are a buyer connected with the brand or a nuorder user(super user)
        if (!isGuestBuyer && isBrandPageOfShowSite) {
            return (
                <div {...this.styles}>
                    <Button
                        label={format("Shop Brand")}
                        onClick={this.handleVisitBrandPortalClick}
                        style={style.button}
                        primary={true}
                        className="visitBrandPortal"
                    />
                </div>
            );
        } else if (isGuestBuyer && get(activeBrand, "contact_information.emails.length")) {
            return (
                <div {...this.styles}>
                    {displayAllProductsToGuestBuyers && isGuestBuyer && isBrandPageOfShowSite && (
                        <Button
                            label={Globalize.formatMessage("Shop This Brand")}
                            href={`/brand/${activeBrand ? activeBrand._id : ""}/gallery`}
                            onClick={this.handleTrackShopBrandClick}
                            style={style.button}
                            className="seeMoreProducts"
                        />
                    )}
                    {/* always display, move conditions outside */}
                    <div className="requestAccess" style={requestAccessStyle}>
                        <Button
                            data-test={DATATEST.REQUEST_BRAND_ACCESS.CONNECT_WITH_THIS_BRAND}
                            onClick={this.handleShowDialog(true)}
                            label={
                                isPendingConnection
                                    ? Globalize.formatMessage("Connection is Pending")
                                    : Globalize.formatMessage("Connect with this Brand")
                            }
                            primary={true}
                            style={style.button}
                            className="requestCTA"
                            large={large}
                            disabled={isPendingConnection}
                        />
                        {/* <div className="requestAccessTooltip">
                            {isPendingConnection
                                ? Globalize.formatMessage("Please wait until brand reviews your connection request")
                                : Globalize.formatMessage("Connect with this brand to see all available products and place orders")}
                            <div className="triangle" />
                        </div> */}
                    </div>

                    {open && (
                        <RequestAccessPopup
                            brandInfo={brandInfo}
                            disabled={isFetching}
                            onCloseDialog={this.handleShowDialog(false)}
                            onMakeAccessRequest={onMakeAccessRequest}
                            onCreateBuyerProfile={onCreateBuyerProfile}
                            isBrandPageOfShowSite={isBrandPageOfShowSite}
                            onClearCompany={onClearCompany}
                            onClearBrand={onClearBrand}
                        />
                    )}
                </div>
            );
        } else if (showDialog) {
            return (
                <RequestAccessPopup
                    brandInfo={brandInfo}
                    disabled={isFetching}
                    onCloseDialog={this.handleShowDialog(false)}
                    onMakeAccessRequest={onMakeAccessRequest}
                    onClearCompany={onClearCompany}
                    onClearBrand={onClearBrand}
                />
            );
        } /* else if (!isGuestBuyer && pathname && pathname.indexOf("brand-profile") !== -1) {
            return (
                <div {...this.styles}>
                    <div className="requestAccess">
                        <Button
                            label={Globalize.formatMessage("See More Products")}
                            href={`/brand/${activeBrand ? activeBrand._id : ""}/gallery`}
                            onClick={this.displayAllProductsToGuestBuyers}
                            style={style.button}
                            className="seeMoreProducts"
                        />
                    </div>
                </div>
            );
        }*/

        return null;
    }
}

export default RequestAccessHeader;
